import './index.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { validateSurface } from '../../globals.js';
import { Tooltip } from '../../tooltips/tooltip/index.js';
import 'react';
import styles from './label.module.scss.js';
import getOS from '../../utilities/check-os/index.js';
import '../../_virtual/_tslib.js';
import '../../utilities/use-viewport/index.js';

const Label = ({ disabled = false, label, required = true, surface: surfaceProp = 'lightPrimary', helperText, helperTextPosition, id, htmlFor, onClick, 'data-testid': testId = 'label-text', tooltip, }) => {
    const surface = validateSurface(surfaceProp);
    const labelStyles = [styles.label];
    const labelTextStyles = [styles.labelText, styles[surface.toLowerCase()]];
    const optionalBadgeStyles = [
        styles.optionalBadge,
        styles[surface.toLowerCase()],
    ];
    const hasTooltip = (tooltip && tooltip.title) || (tooltip && tooltip.children);
    const isAndroidDevice = getOS() === 'android';
    const isAppleDevice = getOS() === 'ios';
    if (label)
        labelStyles.push(styles.hasLabelText);
    if (helperText)
        labelStyles.push(styles.hasHelperText);
    if (helperTextPosition === 'right')
        labelStyles.push(styles.helperTextRight);
    if (disabled) {
        labelTextStyles.push(styles.disabled);
        optionalBadgeStyles.push(styles.disabled);
    }
    return (jsx("label", { className: labelStyles.join(' '), "data-testid": testId, id: id, htmlFor: htmlFor, onClick: onClick ? (e) => onClick(e) : undefined, children: jsxs("p", { className: styles.description, id: `${id}-text`, children: [jsx("span", { className: labelTextStyles.join(' '), children: label }), !required && (jsx("span", { className: optionalBadgeStyles.join(' '), id: `${id}-optional-badge`, "aria-label": isAndroidDevice || isAppleDevice ? 'Optional' : label, children: "Optional" })), hasTooltip && (jsx("span", { className: styles.tooltipWrapper, children: jsx(Tooltip, Object.assign({}, (tooltip && tooltip), { size: "small", disabled: disabled, title: tooltip.title, surface: surface, ariaLabel: `${label} tooltip`, children: tooltip.children })) }))] }) }));
};

export { Label, Label as default };
